import { formatRut } from '@wareclouds/frontend-common/b2c';

export const mapBankAccountFieldsCl = ({
  bankAccountData = [],
  bankListData = [],
}) => {
  if (!bankAccountData || !bankAccountData.data) {
    return null;
  }

  const { data } = bankAccountData;
  const rutAccount = data?.accounts?.RUT;
  const resolvedBankAccount = rutAccount || data;

  if (!resolvedBankAccount) {
    return null;
  }

  const bankFound = bankListData.find(
    (b) => b.value === resolvedBankAccount?.id_bank
  );
  const accountTypeFound = bankFound?.accountTypes?.find(
    (accountType) =>
      accountType.value === resolvedBankAccount?.account_data?.account_type
  );

  return {
    rut: formatRut(resolvedBankAccount?.account_data?.rut) || '',
    bank: bankFound || null,
    accountType: accountTypeFound || null,
    accountNumber: resolvedBankAccount?.account_data?.account_number || '',
  };
};
